import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalEmbedOnce extends React.Component {

  constructor(props) {
    super(props);
    this.state = {ref_id:""};
  }

  render() {
    if(this.props.shouldShow) {
      const submit_disabled = this.state.ref_id.trim() === "";
      let select = "", select_options = [], embed_display = "", poll_index = this.props.apiData["poll-index"], embed_once = this.props.apiData["embed-once"];
      if(poll_index !== undefined) {
        let value = this.state.ref_id;
        if(embed_once !== undefined && embed_once.data && embed_once.data.ref_id && embed_once.data.ref_id.length !== 0) value = embed_once.data.poll_ref_id;
        select_options = poll_index.data.map(function(item, i) {
          return <option key={i} value={item.ref_id}>{item.name}</option>;
        });
        select = <select value={value} onChange={(e) => handleChange(this, "ref_id", e)}>{select_options}</select>;

        if(embed_once !== undefined && embed_once.data && embed_once.data.ref_id && embed_once.data.ref_id.length !== 0) {
          embed_display = poll_index.data.map(function(item, i) {
            if(item.ref_id === embed_once.data.poll_ref_id) {
              let content = item;
              let iframeHeight = "153"; // 1 = 153px, 2 = 184px, 3 = 215px
              if(content.options.length === 2) {iframeHeight = "184"} else if(content.options.length === 3) {iframeHeight = "215"}
              let poll_url = "poll";

              return <div key={i}>
                <p style={{fontSize:"90%", marginBottom:"0", display:"inline-block"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["core_polls_view_embed"][this.props.app_language]}}></p>
                <div style={{fontSize:"79%"}}><p className="rfq-description">{this.props.i18n_texts["core_polls_view_embed_description"][this.props.app_language]}</p>
                <pre style={{fontSize:"90%"}}>&lt;iframe src=&quot;https://citrus.polymedia.nl/{poll_url}/{embed_once.data.ref_id}?embed&ap&quot; height=&quot;{iframeHeight}&quot; style=&quot;border:0;width:100%&quot;&gt;&lt;/iframe&gt;</pre></div>
                <div style={{fontSize:"90%", borderTop:"1px solid #ddd", margin:"2em 3em", height:"0"}}><span style={{marginTop:"-12px", display:"block", textAlign:"center"}}><span style={{padding:"9px", background:"#fff", color:"#888"}}>{this.props.i18n_texts["core_polls_view_andor"][this.props.app_language]}</span></span></div>
                <p style={{fontSize:"90%", marginBottom:"0", display:"inline-block"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["core_polls_view_share"][this.props.app_language]}}></p>
                <div style={{fontSize:"79%"}}><p className="rfq-description">{this.props.i18n_texts["core_polls_view_share_description"][this.props.app_language]}</p>
                <pre style={{fontSize:"90%"}}>https://citrus.polymedia.nl/{poll_url}/{embed_once.data.ref_id}?ap</pre></div>
              </div>;
            }
          }.bind(this));
        }
      }

      return (
        <ModalWrapper switchState={this.props.close} mainClass="create-poll">
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div>{select}</div>
            <div><input type="submit" value={this.props.i18n_texts["core_polls_once"][this.props.app_language]} disabled={submit_disabled} /></div>
          </form>
          {embed_display}
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {ref_id} = this.state;
    const submit_disabled = ref_id.trim() === "";
    if(!submit_disabled) {
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/embedonce-create", JSON.stringify({session_token:this.props.session_token, ref_id}), null, true, false, false, false, false, null, "embed-once");
      this.setState({ref_id:""});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalEmbedOnce)



// WEBPACK FOOTER //
// ./src/containers/ModalEmbedOnce.js